import TeamLineup from '@components/team-lineup';
import { SimulatedMatchNotice } from '@components/simulated-match-notice';
import { LiveTeamTotal } from '@components/live-team-total';
import { buildLineups } from '@lib/live/team/build-lineups';
import { useTeamLive } from '@lib/live/team/context';

export const LivePitchSection = () => {
  const { phase, liveTeam, matchStates } = useTeamLive();

  if (phase === 'LOADING' || phase === 'IDLE' || !liveTeam) {
    return (
      <div
        className="w-full max-w-3xl mx-auto rounded-lg bg-neutral-100 animate-pulse"
        style={{ minHeight: '500px' }}
        data-cy="live-pitch-loading"
      />
    );
  }

  if (phase === 'ERROR') {
    return (
      <div
        className="w-full max-w-3xl mx-auto py-8 text-center text-neutral-600"
        data-cy="live-pitch-error"
      >
        We couldn&apos;t load your live team. Please refresh and try again.
      </div>
    );
  }

  const { starting, bench } = buildLineups(
    liveTeam.starting,
    liveTeam.bench,
    matchStates,
    liveTeam.activeChip ?? null
  );

  return (
    <div data-cy="live-pitch-section">
      {/* Above the pitch rather than below it: the marking has to be read
          before the points are, not after. */}
      <SimulatedMatchNotice />
      <LiveTeamTotal />
      <div className="mt-6">
        <TeamLineup starting={starting} bench={bench} />
      </div>
    </div>
  );
};
